import { render, staticRenderFns } from "./BusinessUserInfo.vue?vue&type=template&id=3bcbab32&scoped=true&"
import script from "./BusinessUserInfo.vue?vue&type=script&lang=js&"
export * from "./BusinessUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUserInfo.vue?vue&type=style&index=0&id=3bcbab32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcbab32",
  null
  
)

export default component.exports